import React, {useRef} from "react";
import HubspotForm from 'react-hubspot-form';

export const GrantFormTwoSpanish = () => {
  const hubspotFormRef = useRef(null);

  return (
    <HubspotForm
      ref={hubspotFormRef}
      portalId='2784460'
      formId='ec902645-7799-4172-a899-76a4b7688965'
      cssClass="position-relative contact-form"
      submitButtonClass="btn"
      loading={<div>Loading...</div>}
    />
  )
}